(() => {
  if (window.hsWorldSeatInstalled) return;
  window.hsWorldSeatInstalled = true;
  const remembered = new Map();
  const control = () => document.querySelector('#MainContent [data-hs-world-seat]');
  const pickerFor = box => document.getElementById(box.dataset.hsPicker);
  const groupsFor = picker => Array.from(picker.querySelectorAll('fieldset'));
  const selectedFor = groups => groups.map(group => group.querySelector('input:checked')?.value);
  const isMesh = value => /Pinstripe/i.test(value || '');
  const dataFor = picker => JSON.parse(picker.querySelector('script[type="application/json"]').textContent);
  const setVariant = (groups, variant) => groups.forEach((group, i) => {
    group.querySelectorAll('input[type="radio"]').forEach(input => {input.checked = input.value === variant.options[i];});
  });
  const sync = () => {
    const box = control();
    if (!box) return;
    const picker = pickerFor(box);
    if (!picker) return;
    const groups = groupsFor(picker);
    if (groups.length !== 3) return;
    const selected = selectedFor(groups);
    const mesh = isMesh(selected[2]);
    const type = mesh ? 'mesh' : 'upholstered';
    box.dataset.hsSeat = type;
    if (!mesh) remembered.set(picker.dataset.url, selected[2]);
    box.querySelectorAll('[data-hs-seat-choice]').forEach(button => {
      button.setAttribute('aria-pressed', String(button.dataset.hsSeatChoice === type));
    });
    box.querySelector('[data-hs-seat-label]').textContent = box.querySelector(`[data-hs-seat-choice="${type}"]`).textContent;
    box.querySelectorAll('[data-hs-seat-help]').forEach(help => {help.hidden = help.dataset.hsSeatHelp !== type;});
    const colourLabel = groups[2].querySelector('[data-hs-seat-colour-label]');
    if (colourLabel) {
      if (!colourLabel.dataset.hsMeshLabel) colourLabel.dataset.hsMeshLabel = box.dataset.hsMeshLabel;
      colourLabel.textContent = mesh ? box.dataset.hsMeshLabel : groups[2].querySelector('.form__label.visually-hidden').textContent;
    }
    groups[2].querySelectorAll('input[type="radio"]').forEach(input => {
      const hidden = isMesh(input.value) !== mesh;
      input.disabled = hidden;
      const label = document.getElementById(input.id)?.nextElementSibling;
      if (label?.matches('.apex-swatch__wrap')) label.dataset.hsSeatHidden = String(hidden);
    });
    document.querySelectorAll('[data-hs-world-seat-depth]').forEach(element => {
      element.textContent = mesh ? '15.7–18.3 in (399–464 mm)' : '16.1–18.5 in (409–470 mm)';
    });
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-hs-seat-choice]');
    const box = button?.closest('[data-hs-world-seat]');
    if (!box || button.disabled || button.getAttribute('aria-pressed') === 'true') return;
    const picker = pickerFor(box);
    if (!picker) return;
    const groups = groupsFor(picker);
    const selected = selectedFor(groups);
    const mesh = button.dataset.hsSeatChoice === 'mesh';
    const candidates = dataFor(picker).filter(variant => isMesh(variant.options[2]) === mesh);
    const available = candidates.filter(variant => variant.available);
    const score = variant => (variant.options[0] === selected[0] ? 8 : 0) + (variant.options[1] === selected[1] ? 4 : 0) + (variant.options[2] === remembered.get(picker.dataset.url) ? 1 : 0);
    const variant = (available.length ? available : candidates).reduce((best, item) => !best || score(item) > score(best) ? item : best, null);
    if (!variant) return;
    setVariant(groups, variant);
    sync();
    groups[2].querySelector('input:checked').dispatchEvent(new Event('change', {bubbles:true}));
  });
  document.addEventListener('change', event => {
    const box = control();
    if (!box || !pickerFor(box)?.contains(event.target)) return;
    sync();
  });
  document.addEventListener('hs:mount:change', sync);
  if (typeof subscribe === 'function') subscribe(PUB_SUB_EVENTS.variantChange, sync);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync, {once:true}); else sync();
})();
